import React from 'react';
import CurrentUserDetail from '../../../model/currentuser/CurrentUserDetail';

export interface UserContextProperties {
  pouzivatel: CurrentUserDetail;
  fetchProfile: () => void;
}

export default React.createContext<UserContextProperties>({
  pouzivatel: null,
  fetchProfile: () => { /* noop */ },
});
